export default "__VITE_ASSET__CE6P2cOo__"